


























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { ICatalogCategoryItem } from '~/assets/interfaces/catalog'
import MixinGeneral from '~/assets/mixins/general'

@Component({
  components: {
    ComponentImage: () => import('~/components/images/image.vue'),
  },
})
export default class ComponentCatalogCategoryItem extends mixins(MixinGeneral) {
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: ICatalogCategoryItem

  @Prop({ type: Boolean }) private small!: boolean
  @Prop({ type: Boolean, default: false }) private isMobileType2!: boolean

  private mounted(): void {
    this.$emit('loaded')
  }

  private get classTitle() {
    return {
      [this.$style.title]: true,
      [this.$style.small]: this.small,
    }
  }

  private get classIsMobileType2() {
    return {
      [this.$style.isMobileType2]: this.isMobileType2,
    }
  }
}
